import { Colorpicker, ColorpickerEvents } from "@dhx/ts-colorpicker";
import { el } from "@dhx/ts-common/dom";
import { IEventSystem } from "@dhx/ts-common/events";
import { PropertyEvents } from "../types";
import { Text } from "./Text";
import { Popup } from "@dhx/ts-popup";

export class ColorPicker extends Text {
	private _colorPicker: any;
	private _popup: Popup;

	constructor(config, ev: IEventSystem<PropertyEvents>) {
		config.validation = config.validation || "color";
		super(config, ev);

		this._colorPicker = new Colorpicker(null);
		this._colorPicker.events.on(ColorpickerEvents.change, color => {
			this._popup.hide();
			if (this._config.value !== color) {
				this.setValue(color);
			}
		});
		this._popup = new Popup();
		this._popup.attach(this._colorPicker);
		this._handlers.show = e => this._showPopup(e.target);
	}

	toVDOM() {
		return el(".edit-section.color-edit", { _key: this._uid }, [
			el(".section-title", this._config.label || ""),

			el(".color-edit", [
				el(
					".color_picker_wrap",
					{
						onclick: this._handlers.show,
					},
					[
						el("label.input_element", { for: this._config.id }, [
							el("input", {
								type: "text",
								name: this._config.id,
								value: this._config.value,
								disabled: true,
							}),
							el(".input_icon_wrap", [
								el(".input_icon", {
									style: {
										backgroundColor: this._config.value,
									},
								}),
							]),
						]),
					]
				),
			]),
		]);
	}

	private _showPopup(node: any) {
		this._colorPicker.setValue(this._config.value);
		this._popup.show(node);
	}
}
